import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Trans } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { Field } from 'react-final-form';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import validations from 'validations';
import AgreeToTcModal from './components/AgreeToTcModal';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';

import './AgreeToTcField.styles.scss';

type AgreeToTcFieldProps = {
  className?: string;
  termsAndConditionsContent: string;
};

const AgreeToTcField: React.FC<AgreeToTcFieldProps> = (props) => {
  const { className, termsAndConditionsContent } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const classes = classNames('agree-to-tc-field', className);

  const termsAndConditionButton = useMemo(
    () => <Button variant="link" onClick={modal?.open} />,
    [modal?.open],
  );

  return (
    <>
      <Field
        className={classes}
        name="agreeToTC"
        component={CheckboxField}
        type="checkbox"
        validate={validations.checkedFieldValidation()}
        label={
          <Trans
            i18nKey="agreeToT&C"
            components={{
              termsAndConditionButton,
            }}
          />
        }
      />

      <AgreeToTcModal
        ref={modalRef}
        termsAndConditionsContent={termsAndConditionsContent}
      />
    </>
  );
};

export default AgreeToTcField;
